import actionTypes from "./actionTypes";
export default {
    setBackUrlHash: (backUrlHash) => ({
        type: actionTypes.SET_BACK_URL_HASH,
        backUrlHash
    })
};
